export default __webpack_public_path__ + "static/media/1862.df1c4147.png";